// Environment Configuration
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// API Configuration
export const API_CONFIG = {
  // Base URL - uses environment variable or falls back to environment-based defaults
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.offr.uz',

  // Request timeout
  TIMEOUT: parseInt(process.env.REACT_APP_TIMEOUT) || 100000,

  // Environment info
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development',
};

// Maps Configuration
export const MAPS_CONFIG = {
  YANDEX_API_KEY: process.env.REACT_APP_YANDEX_API_KEY || '19a5e7ef-f60b-451a-a97d-860b9560989b',
};

// Export for convenience
export const { BASE_URL, TIMEOUT, ENVIRONMENT } = API_CONFIG;
export const { YANDEX_API_KEY } = MAPS_CONFIG;

// Development helpers
export const isDev = isDevelopment;
export const isProd = isProduction;

// Log current configuration in development
// if (isDevelopment && process.env.REACT_APP_DEBUG === 'true') {
//   console.log('🔧 Environment Configuration:', {
//     BASE_URL: API_CONFIG.BASE_URL,
//     ENVIRONMENT: API_CONFIG.ENVIRONMENT,
//     TIMEOUT: API_CONFIG.TIMEOUT,
//   });
// }
